import { render, staticRenderFns } from "./ClcShortLong.vue?vue&type=template&id=4a994b88&"
import script from "./ClcShortLong.vue?vue&type=script&lang=js&"
export * from "./ClcShortLong.vue?vue&type=script&lang=js&"
import style0 from "./ClcShortLong.vue?vue&type=style&index=0&id=4a994b88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports